<template>
  <nav class="nav-account">
    <router-link
      v-for="(item, i) in navBar"
      :key="i"
      v-profile-guard="item.action"
      class="nav-account__item"
      active-class="active"
      :to="{ name: item.route }"
      :exact="item.exact"
    >
      {{ $t(item.label) }}</router-link
    >
  </nav>
</template>
<script>
import navBarItems from '@/utils/NavBar';
import { mapState } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      navBar: null
    };
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions.permissions
    })
  },
  created() {
    this.navBar = navBarItems;
  }
};
</script>
